export default "__VITE_PUBLIC_ASSET__2f63f2ef__"